import React, { useState, useEffect } from 'react';
import ItemsDisplay from '../Menu/components/Items/ItemsDisplay';
import { Item } from '../Menu/types';
import { getAllItemsByLocalId } from '../../../../crud/menu_api/items';
import { getMenuCategoriesByLocalId } from '../../../../crud/menu_api/categories';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

const Items: React.FC = () => {
  const [originalItems, setOriginalItems] = useState<Item[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const {categoryId} = useParams<{ categoryId?: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  // Check if user came from categories page
  const cameFromCategories = location.state?.fromCategories === true;

  // Function to handle going back to categories
  const handleGoBack = () => {
    navigate('/App/Categories');
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') ?? '{}');
    const localId = Number(user.local_id) || 0;
    setLoading(true);

    Promise.all([
      getMenuCategoriesByLocalId(localId),
      getAllItemsByLocalId(localId),
    ])
      .then(([catRes, itemsRes]) => {
        if (itemsRes?.data) {
          const sorted = itemsRes.data.sort((a: Item, b: Item) => a.label.localeCompare(b.label));
          setOriginalItems(sorted);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner text="Cargando ítems..." transparent />;

  return (
    <div className="items-page-container">
      <div className="mp-page-header-container">
      <h2 className="title">Ítems</h2>
      <div className="buttons">
      </div>
      </div>

      <ItemsDisplay
        items={originalItems}
        categoryId={categoryId ? categoryId : undefined}
        setSelectedCategory={cameFromCategories ? handleGoBack : undefined}
      />
    </div>
  );
};

export default Items;
